import { render, staticRenderFns } from "./VendorShip.vue?vue&type=template&id=139122c7&scoped=true"
import script from "./VendorShip.vue?vue&type=script&lang=js"
export * from "./VendorShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139122c7",
  null
  
)

export default component.exports